import styled, { css } from 'styled-components';

import { ILabelProps } from './Label.types';

const Label = styled.span<Required<Pick<ILabelProps, 'size'>>>`
  ${({ size, theme }) => css`
    ${size === 'xsmall' && theme.label.extraSmall.bold};
    ${size === 'small' && theme.label.small.bold};
    ${size === 'medium' && theme.label.medium.bold};
    ${size === 'large' && theme.label.large.bold};
    ${size === 'xlarge' && theme.label.extraLarge.demi};
    color: ${theme.text.onSurface.strong};
  `}
`;

export { Label };
